import createCrudModule from '@modules/crud/createCrudModule'

import JobModel from './job.model.js'

export { JobModel }

export default createCrudModule('job', JobModel.getDefaults());


// WEBPACK FOOTER //
// ./src/modules/job/job.module.js